console.log("Tabletop Goodies - Script - Numbers");

TTG = (function (parent) {
  const result = {};

  result.getDecimalPartLength = function (n) {
    var s = "" + +n;
    var match = /(?:\.(\d+))?(?:[eE]([+\-]?\d+))?$/.exec(s);
    if (!match) {
      return 0;
    }
    return Math.max(
      0, // lower limit.
      (match[1] === "0" ? 0 : (match[1] || "").length) - // fraction length
        (match[2] || 0)
    ); // exponent
  };

  result.isEven = function (number) {
    return number % 2 === 0;
  };

  parent.Numbers = result;
  return parent;
})(TTG);
